export const ACTIVITIES=[
  {id:'tempo',title:'快還是慢？',icon:'🐢',accent:'快 / 慢',prompt:'聽一聽：你的動作想快一點，還是慢一點？'},
  {id:'energy',title:'強還是弱？',icon:'💪',accent:'強 / 弱',prompt:'音樂變強時，試試把動作變大。'},
  {id:'direction',title:'音樂的方向',icon:'↗️',accent:'上 / 下 / 左 / 右',prompt:'這句音樂想往哪一個方向走？'},
];
